export default __webpack_public_path__ + "static/media/text_box.2e1a8a7b.png";